module.exports = __webpack_public_path__ + "static/media/aq.faebed7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/aq.svg
// module id = 50
// module chunks = 0